/**
 * Vonex Software Front-End Boilerplate
 *
 * @package	Vonex Boilerplate
 * @author	Vonex Dev Team
 * @since	Version 1.0.0
 * @reference https://bitbucket.org/vonex/styleguide/src/master/
 *
 * This is where you will set all components
 * that needs to be global.
 *
 * Example:
 *
 * import Vue from 'vue';
 * import ComponentSample from '@/components/ComponentSample.vue';
 *
 * Vue.component('component-sample', ComponentSample);
 *
 */

import Vue from 'vue'
import PreLoader from '@/components/common/pre-loader'
import HTTPResponse from '@/components/common/http-response'
import ProcessLoader from '@/components/common/process-loader'
import AppSearch from '@/components/common/app-search'

Vue.component('pre-loader', PreLoader)
Vue.component('http-response', HTTPResponse)
Vue.component('process-loader', ProcessLoader)
Vue.component('app-search', AppSearch)
